// src/App.js
import React, { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Cookies from "universal-cookie";

// 📦 Estilos
import "../src/css/sb-admin-2.css";

// 📦 Componentes
import Home from "./components/Home";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import Solicitud from "./components/Solicitudes";
import InfoSedes from "./components/Sedes/InfoSedes";
import Perfil from "./components/Perfil";
import Instituciones from "./components/Institucion/Instituciones";
import RepresentanteLegal from "./components/RepresentanteLegal/RepresentanteLegal";
import GerenteInstitucion from "./components/Gerente/GerenteInstitucion";
import ProcesoSolicitud from "./components/ProcesoSolicitud";
import ProcesoAutoevaluacion from "./components/ProcesoAutoevaluacion";
import ArchivoSistemaCalidad from "./components/ArchivoSistemaCalidad";
import ProcesoCargueMasivo from "./components/ProcesoCargueMasivo";
import Pruebas from "./components/PruebaDocs/Pruebas";
import InfoTrabajadores from "./components/Funciones/InfoTrabajadores";
import InfoServicios from "./components/Funciones/InfoServicios";
import InfoCapacidadInstalada from "./components/Funciones/InfoCapacidadInstalada";
import InfoDocumentacionSolicitudes from "./components/Funciones/InfoDocumentacionSolicitud";
import InfoEstandares from "./components/Funciones/InfoEstandares";
import Indicadores from "./components/Indicadores";
import Equipo from "./components/Equipo";
import AsignarEquipo from "./components/AsignarEquipo";
import Imagen from "./components/Imagen";
import Registro from "./components/Registro";
import RecuperarContrasena from "./components/RecuperarContraseña";
import IndexEvaluador from "./components/Evaluador/IndexEvaluador";
import AsignarTareas from "./components/Evaluador/AsignarTareas";
import InfoUsuarios from "./components/GestionUsuarios/InfoUsuarios";
import Footer from "./components/Footer";
import BackGround from "./components/BackGround";
import LineChart from "./components/PruebaDocs/LineChart";
import CreaEncuesta from "./components/Encuestas/CreaEncuesta";
import Load from "./components/Loader/Loadding";
import CreaEncuestaUsuario from "./components/Encuestas/CreaEncuestaUsuario";
import InfoServiciosModalidad from "./components/Funciones/InfoServiciosModalidad";
import InfoRepositorio from "./components/InfoRepositorio";
import EstandarAsistencial from "./components/Autoevaluacion/Estandar/EstandarAsistencial";
import InforEncuesta from "./components/Encuestas/InfoEncuesta";
import SedeAdmin from "./components/Sedes/SedeAdmin";
import RepresentanteAdmin from "./components/RepresentanteLegal/RepresentanteAdmin";
import GerenteAdmin from "./components/Gerente/GereteAdmin";
import CopyInstitucion from "./components/Institucion/InstitucionAdmin";
import CargaOmConsecutiva from "./components/CargaOm/CargaOmConsecutiva";
import PerfilAutoevaluacio from "./components/Institucion/PerfilAutoevaluacion";
import CreaInstitucion from "./components/Institucion/CreaInstitucion";
import CreaTrabajadores from "./components/Modals/crear/CreaTrabajadores";
import CreaServicios from "./components/Modals/crear/CreaServicios";
import CreaCapacidad from "./components/Modals/crear/CreaCapacidad";
import InfoPerfilAdmin from "./components/Institucion/InfoPerfilAdmin";
import InstitucionPerfilAdmin from "./components/Institucion/InstitucionPerfilAdmin";
import SelectAnidado from "./components/SelectAnidado/SelectList";
import GestionarOm from "./components/CargaOm/GestionarOm";
import OmPorUsuario from "./components/CargaOm/OmPorUsuario";
import ServiciosSede from "./components/Funciones/ServiciosSede";
import Encuestas from "./components/Encuestas/Encuestas";
import PresentaEncuestas from "./components/Encuestas/PresentaEncuestas";
import OmNoAgrupadas from "./components/CargaOm/OmNoAgrupadas";
import InformeAuto from "./components/Informes/InformeAuto";
import MyPDF from "./components/PDF/ReactPDF";
import RepositorioEvaluador from "./components/Evaluador/RepositorioEvaluador";
import TrabajadoresEvaluador from "./components/Evaluador/TrabajadoresEvaluador";
import InfoAnexosEvaluador from "./components/Evaluador/AnexosEvaluador";
import IndicadorEvaluadorAyB from "./components/Evaluador/IndicadoresAyBevaluador";
import PdfEvaluador from "./components/PDF/PdfEvaluador";
import PdfAgenda from "./components/PDF/PdfAgenda";
import GestionOmLider from "./components/Evaluador/GestionOmLider";
import AsignarOm from "./components/Evaluador/AsignarOm";
import OMmasivoEvaluador from "./components/Evaluador/OMmasivoEvaluador";
import InformeEvluador from "./components/Informes/InformeEvaluador";
import InfoDocumentacionData from "./components/Funciones/InfoDocuemntacionDta";
import PriorizaIndicador from "./components/Evaluador/PriorizaIndicador";
import MiniGrafico from "./components/FichaTecnica/MiniGrafico";
import ResumenOm from "./components/CargaOm/ResumenOm";
import InformeFinal from "./components/Informes/InformeFinal";
import OmNoAgrupadasEvaluador from "./components/Evaluador/OmNoAgrupadaEvaluador";
import IndexJunta from "./components/Evaluador/IndexJunta";
import AsignarDirector from "./components/AsignarDirector";
import PdfProgramacion from "./components/PDF/PdfProgramacion";
import ManualEvaluador from "./components/Manuales/ManualEvaluador";
import InfoServiciosModalidadEvaluador from "./components/Evaluador/ServicioModalidadEvaludaor";
import BotonFlotanteLector from "./components/Lector";
import UsuarioPerfil from "./components/GestionUsuarios/UsuarioPerfil";
import RestauraContrasena from "./components/RestauraContraseña";
import InformeEvaluadorOptimizado from "./components/Informes/InformeEvaluadorOptimizado";
import VerEquipoEvaluador from "./components/VerEquipoEvaluador";
import EncuestasPorTipo from "./components/Encuestas/EncuestasPorTipo";
import DetalleEncuesta from "./components/Encuestas/DetalleEncuestas";
import DetallesEncuesta from "./components/Encuestas/DetalleEncuestas";
import OmSolucionadas from "./components/CargaOm/OmSolucionada";
import RepositorioFichas from "./components/ModuloFichasRepositorio/RepositorioFichas";
import SolicitudesDirector from "./components/SoliictudesDirector";
import AsignarJunta from "./components/AsignarJunta/AsignarJunta";
import SolicitudesJunta from "./components/AsignarJunta/SolicitudesJunta";
import ConflictoInteres from "./components/AsignarJunta/ConflictoInteres";
import EquipoJunta from "./components/AsignarJunta/EquipoJunta";
import ComentariosSolicitud from "./components/AsignarJunta/ComentariosJunta";
import OmGrupo from "./components/CargaOm/CreaGrupoOm";
import OmAgrupadas from "./components/CargaOm/OmAgrupadas";

function AppContent() {
  const cookies = new Cookies();
  const [tipoUsuario, setTipoUsuario] = useState("");
  const location = useLocation();

  useEffect(() => {
    const updateTipoUsuario = () =>
      setTipoUsuario(cookies.get("tipo_Usuario") || "");
    updateTipoUsuario();
    const interval = setInterval(updateTipoUsuario, 1000);
    return () => clearInterval(interval);
  }, []);

  // rutas donde NO queremos los <br>
  const noSpacingRoutes = ["/", "/Recuperar", "/RecuperarContrasena"];
  const shouldShowSpacing = !noSpacingRoutes.includes(location.pathname);

  return (
    <>
      <BotonFlotanteLector />
      {tipoUsuario && <Sidebar />}
      {shouldShowSpacing && (
        <>
          <br /> <br /> <br /> <br />
        </>
      )}

      <Routes>
        {/* 🔹 Autenticación */}
        <Route path="/" element={<Login />} />
        <Route path="/Registro" element={<Registro />} />
        <Route path="/Recuperar" element={<RecuperarContrasena />} />
        <Route path="/RecuperarContrasena" element={<RestauraContrasena />} />

        {/* 🔹 Usuario */}
        <Route path="/Home/:username" element={<Home />} />
        <Route path="/PerfilUsuario" element={<UsuarioPerfil />} />
        <Route path="/Perfil" element={<Perfil />} />

        {/* 🔹 Solicitudes */}
        <Route path="/Solicitudes" element={<Solicitud />} />
        <Route
          path="/ProcesoSolicitud/:id/:idInstitucion"
          element={<ProcesoSolicitud />}
        />
        <Route
          path="/ProcesoAutoevaluacion/:id/:idInstitucion/:tipoSolicitud"
          element={<ProcesoAutoevaluacion />}
        />
        <Route
          path="/ProcesoCargueMasivo/:id"
          element={<ProcesoCargueMasivo />}
        />

        {/* 🔹 Funciones */}
        <Route path="/InfoSedes" element={<InfoSedes />} />
        <Route path="/InfoTrabajadores" element={<InfoTrabajadores />} />
        <Route path="/InfoServicios/:id" element={<InfoServicios />} />
        <Route
          path="/InfoServiciosModalidad"
          element={<InfoServiciosModalidad />}
        />
        <Route
          path="/InfoCapacidadInstalada"
          element={<InfoCapacidadInstalada />}
        />
        <Route
          path="/InfoDocumentacion"
          element={<InfoDocumentacionSolicitudes />}
        />
        <Route path="/InfoEstandares" element={<InfoEstandares />} />
        <Route
          path="/InfoDocumentacionData"
          element={<InfoDocumentacionData />}
        />

        {/* 🔹 Gestión Usuarios */}
        <Route path="/InfoUsuarios" element={<InfoUsuarios />} />

        {/* 🔹 Reportes y PDF */}
        <Route path="/InformeAuto/:id/:idSolicitud" element={<InformeAuto />} />
        <Route
          path="/InformePdf/:idInstitucion/:idSolicitud"
          element={<MyPDF />}
        />
        <Route
          path="/PdfEvaluador/:idSolicitud/:idInstitucion"
          element={<PdfEvaluador />}
        />
        <Route
          path="/PdfAgenda/:idSolicitud/:idEvaluador"
          element={<PdfAgenda />}
        />
        <Route
          path="/PdfProgramacion/:idSolicitud/:idEvaluador"
          element={<PdfProgramacion />}
        />
        <Route
          path="/InformeEvaluador/:idInstitucion/:idSolicitud"
          element={<InformeEvluador />}
        />
        <Route
          path="/InformeEvaluadorOptimzado/:idInstitucion/:idSolicitud"
          element={<InformeEvaluadorOptimizado />}
        />
        <Route
          path="/InformeFinal/:id/:idSolicitud"
          element={<InformeFinal />}
        />

        {/* 🔹 Encuestas */}
        <Route path="/Encuesta" element={<CreaEncuesta />} />
        <Route path="/EncuestaUsuario" element={<CreaEncuestaUsuario />} />
        <Route path="/Encuestas" element={<Encuestas />} />
        <Route
          path="/PresentaEncuesta/:idTipo/:idEncuesta/:idSolicitud"
          element={<PresentaEncuestas />}
        />
        <Route
          path="/InfoEncuestas/:tipo/:idSolicitud"
          element={<InforEncuesta />}
        />

        {/* 🔹 Otros */}
        <Route path="/Footer" element={<Footer />} />
        <Route path="/Imagen" element={<Imagen />} />
        <Route path="/fondo" element={<BackGround />} />
        <Route path="/Area" element={<LineChart />} />
        <Route path="/Load" element={<Load />} />
        <Route path="/Grafico" element={<MiniGrafico />} />

        {/* 🔹 OM y Carga */}
        <Route path="/CargaOmConsecutiva" element={<CargaOmConsecutiva />} />

        <Route path="/OmNoAgrupadas" element={<OmNoAgrupadas />} />
        <Route
          path="/OmNoAgrupadasEvaluador/:id/:idSolicitud"
          element={<OmNoAgrupadasEvaluador />}
        />
        <Route path="/GestionarOm" element={<GestionarOm />} />
        <Route path="/OmPorUsuario" element={<OmPorUsuario />} />
        <Route path="/ResumenOm" element={<ResumenOm />} />
        <Route
          path="/OMmasivoEvaluador/:institucion"
          element={<OMmasivoEvaluador />}
        />
        <Route
          path="/AsignarOm/:idSolicitud/:institucion"
          element={<AsignarOm />}
        />
        <Route
          path="/GestionOmLider/:idSolicitud"
          element={<GestionOmLider />}
        />

        {/* 🔹 Admin */}
        <Route path="/SedeAdmin" element={<SedeAdmin />} />
        <Route path="/RepresentanteAdmin" element={<RepresentanteAdmin />} />
        <Route path="/GerenteAdmin" element={<GerenteAdmin />} />
        <Route path="/InstitucionAdmin" element={<CopyInstitucion />} />
        <Route
          path="/InstitucionPerfilAdmin"
          element={<InstitucionPerfilAdmin />}
        />
        <Route path="/PerfilAutoevaluacion" element={<PerfilAutoevaluacio />} />

        {/* 🔹 Creador */}
        <Route path="/CreaInstitucion" element={<CreaInstitucion />} />
        <Route path="/CreaTrabajadores" element={<CreaTrabajadores />} />
        <Route path="/CreaServicios" element={<CreaServicios />} />
        <Route path="/CreaCapacidad" element={<CreaCapacidad />} />

        {/* 🔹 Evaluador */}
        <Route path="/IndexEvaluador/:username" element={<IndexEvaluador />} />
        <Route path="/IndexJunta" element={<IndexJunta />} />
        <Route
          path="/AsignarTareas/:id/:tipoSolicitud"
          element={<AsignarTareas />}
        />
        <Route
          path="/RepositorioEvaluador/:id"
          element={<RepositorioEvaluador />}
        />
        <Route
          path="/InfoTrabajadoresEvaluador/:id"
          element={<TrabajadoresEvaluador />}
        />
        <Route path="/InfoAnexos/:id" element={<InfoAnexosEvaluador />} />
        <Route
          path="/IndicadorEvaluadorAyB/:id"
          element={<IndicadorEvaluadorAyB />}
        />
        <Route path="/PriorizaIndicador" element={<PriorizaIndicador />} />
        <Route
          path="/ServiciosModalidadEvaluador/:id"
          element={<InfoServiciosModalidadEvaluador />}
        />
        <Route path="/ManualEvaluador" element={<ManualEvaluador />} />

        {/* 🔹 Extras */}
        <Route path="/Pruebas" element={<Pruebas />} />
        <Route
          path="/ArchivoSistemaCalidad/:id"
          element={<ArchivoSistemaCalidad />}
        />
        <Route path="/Indicadores" element={<Indicadores />} />
        <Route path="/AsignarEquipo" element={<AsignarEquipo />} />
        <Route path="/Instituciones" element={<Instituciones />} />
        <Route path="/Sede" element={<InfoSedes />} />
        <Route path="/RepresentanteLegal" element={<RepresentanteLegal />} />
        <Route path="/GerenteInstitucion" element={<GerenteInstitucion />} />
        <Route path="/AsignarDirector" element={<AsignarDirector />} />
        <Route path="/ServicioSede/:id" element={<ServiciosSede />} />
        <Route path="/InfoRepositorio" element={<InfoRepositorio />} />
        <Route path="/EquipoEvaluador/:id" element={<Equipo />} />
        <Route path="/OMsolucionada" element={<OmSolucionadas />} />
        <Route path="/RepositorioFichas" element={<RepositorioFichas />} />
        <Route path="/AsignarJunta" element={<AsignarJunta />} />
        <Route
          path="/ConflictoInteres/:id/:asignacion"
          element={<ConflictoInteres />}
        />

        <Route path="/EquipoJunta/:id" element={<EquipoJunta />} />
        <Route
          path="/ComentariosJunta/:id/"
          element={<ComentariosSolicitud />}
        />

        <Route
          path="/SolicitudesJunta/:username"
          element={<SolicitudesJunta />}
        />

        <Route
          path="/SolicitudesDirector/:username"
          element={<SolicitudesDirector />}
        />

        <Route
          path="/DetalleEncuesta/:idEncuesta"
          element={<DetallesEncuesta />}
        />
        <Route
          path="/EncuestaPorTipo/:tipoEncuesta/:solicitud"
          element={<EncuestasPorTipo />}
        />
        <Route path="/OmGrupo" element={<OmGrupo />} />
        <Route path="/OmAgrupadas" element={<OmAgrupadas />} />
        <Route path="/OmAgrupadas/:idInstitucion" element={<OmAgrupadas />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
